export const UI_TOGGLE_SIDEBAR = 'UI_TOGGLE_SIDEBAR';
export const UI_TOGGLE_SETTINGS = 'UI_TOGGLE_SETTINGS';
export const UI_SET_OPEN_POOL = 'UI_SET_OPEN_POOL';
export const UI_SET_OFFLINE = 'UI_SET_OFFLINE';
export const UI_SET_TOAST_POSITION = 'UI_SET_TOAST_POSITION';

export const UI_SHOW_TOAST = 'UI_SHOW_TOAST';
export const UI_CLEAR_TOAST = 'UI_CLEAR_TOAST';

export const UI_TOGGLE_AI_NOTE_MODAL = 'UI_TOGGLE_AI_NOTE_MODAL';
export const UI_SHOW_AI_CHECKER_TOOLTIP = 'UI_SHOW_AI_CHECKER_TOOLTIP';
